import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import {
    TableContentForFactoryRouteWeighReport,
    TableContentForSumLeafCollectionVarianceReport
} from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { FactoryRouteWeighReportSchemaObject } from "../factoryRouteWeighReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';

const screenCode = "FACTORYROUTEWEIGHREPORT";

export function FactoryRouteWeighReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [leafCollectionVariance, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        date: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        date: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(FactoryRouteWeighReportSchemaObject).options({ allowUnknown: true });
    const initialContentRownames = ["filedDate", "fieldCollectionPointName",
        "filedRegistrationNumber", "name", "fieldNumberOfUnits", "fieldGrossAmount_Kg", "fieldNetAmount_Kg", "collectionTypeName"];
    const initialSumTableContentRownames = ["fieldCollectionPointName", "fieldNumberOfUnits", "fieldGrossAmount_Kg", "fieldNetAmount_Kg",];

    const [contentRowNames, setContentRowNames] = useState([]);
    const [fieldColumnNames, setFieldColumnNames] = useState([]);
    const [sumFieldContentRowNames, setSumFieldContentRowNames] = useState([]);

    const initialCsvHeaders = [
        { label: "Date", value: "filedDate" },
        { label: "Route Name", value: "fieldCollectionPointName" },
        { label: "Reg Number", value: "filedRegistrationNumber" },
        { label: "Reg Name", value: "name" },
        { label: "Bag Count", value: "fieldNumberOfUnits" },
        { label: "Gross /Kg", value: "fieldGrossAmount_Kg" },
        { label: "Net /Kg", value: "fieldNetAmount_Kg" },
        { label: "Leaf Type", value: "collectionTypeName" }
    ]
    const [csvHeaders, setCsvHeaders] = useState([]);

    const [reportData, setReportData] = useState([]);
    const [fieldDeductions, setFieldDeductions] = useState([]);
    const [factoryDedutions, setFactoryDeductions] = useState([]);
    const [fullTotalRow, setFullTotalRow] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [sumTableData, setSumTableData] = useState([]);
    const [sumTableTotal, setSumTableTotal] = useState([]);


    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionVariance.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionVariance.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"

        });
        setIsTableHide(true);
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            factoryID: target.value,
            routeID: "0"
        });
        setIsTableHide(true);
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: target.value,
        });
        setIsTableHide(true);
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            date: target.value,
        });
        setIsTableHide(true);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, FactoryRouteWeighReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFACTORYROUTEWEIGHREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionVariance.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionVariance.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionVariance);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionVariance);

        const result = await services.getLeafCollectionVarianceReportData(leafCollectionVariance);

        var contentResult = generateTableInitializationData(result);

        var mergedByFieldResult = mergeFieldData(result.fieldData);
        var finalResult = mergeByUser(mergedByFieldResult);

        var sumTableData = mergeSumTableFieldData(result.fieldSumData, finalResult.bagCountByCp);
        setSumTableData(sumTableData);
        var totalRowResult = calculateTotal(finalResult.data);

        if (finalResult.data.length > 0) {
            setIsTableHide(false);
            setReportData(finalResult.data);
            createDataTable(contentResult, ["#factoryRouteWeighReport", "#factoryRouteWeighReportPdf"]);

            generateCsvData(finalResult.data, totalRowResult, contentResult);
        }
    }

    function mergeByUser(data) {
        var mergedData = [];
        var bagsByCOllectionPoint = [];

        data.forEach((x, i) => {

            if (bagsByCOllectionPoint.length === 0) {
                bagsByCOllectionPoint.push({ id: x.fieldCollectionPointID, value: 1 });
            } else {
                var duplicateCollectionRecord = bagsByCOllectionPoint.find(y => parseInt(y.id) === parseInt(x.fieldCollectionPointID));

                if (duplicateCollectionRecord) {
                    duplicateCollectionRecord.value = duplicateCollectionRecord.value + 1;
                } else {
                    bagsByCOllectionPoint.push({ id: x.fieldCollectionPointID, value: 1 });
                }
            }

            if (mergedData.length === 0) {
                x.fieldNumberOfUnits = 1;
                mergedData.push(x)
            } else {
                var duplicate = mergedData.find(y => y.filedRegistrationNumber === x.filedRegistrationNumber
                    && parseInt(y.fieldCollectionPointID) === parseInt(x.fieldCollectionPointID) && y.filedDate === x.filedDate
                    && parseInt(y.collectionTypeID) === parseInt(x.collectionTypeID));

                if (duplicate) {
                    for (var property in duplicate) {
                        if (property.includes("_Kg")) {
                            duplicate[property] = checkValueisUndifined(duplicate[property]) + checkValueisUndifined(x[property]);
                        } else if (property === "fieldNumberOfUnits") {
                            duplicate.fieldNumberOfUnits = checkValueisUndifined(duplicate.fieldNumberOfUnits) + 1;
                        }
                    }
                } else {
                    x.fieldNumberOfUnits = 1;
                    mergedData.push(x)
                }
            }
        });

        return {
            data: mergedData,
            bagCountByCp: bagsByCOllectionPoint
        };
    }

    function calculateTotal(data) {
        var total = [];
        var bagCount = 0;

        data.forEach(x => {
            for (var property in x) {
                if (property.includes("_Kg")) {
                    total.push({ name: property, value: x[property] });
                } else if (property === "fieldNumberOfUnits") {
                    bagCount = bagCount + checkValueisUndifined(x.fieldNumberOfUnits);
                }
            }
        });

        const res = Array.from(total.reduce(
            (m, { name, value }) => m.set(name, (m.get(name) || 0) + value), new Map
        ), ([name, value]) => ({ name, value }));

        res.bagCount = bagCount;

        setFullTotalRow(res);
        return res;
    }

    function generateCsvData(data, totalRowResult, contentResult) {

        var copyOfData = _.cloneDeep(data);
        var newRecord = { filedDate: "Total" }

        newRecord.fieldNumberOfUnits = totalRowResult.bagCount;
        totalRowResult.forEach(x => {
            newRecord[x.name] = x.value === undefined ? (0).toFixed(2) : x.value.toFixed(2);
        });

        copyOfData.push(newRecord);
        setCsvData(copyOfData);
    }

    function generateTableInitializationData(data) {

        var copyOfInitialContentRownames = initialContentRownames;
        var copyOfInitialCsvHeaders = initialCsvHeaders;
        var copyOfInitialSumTableContentRownames = initialSumTableContentRownames;

        var fieldDeductionNames = [];
        var fieldDeductionIds = [];


        var csvFieldsData = [];

        data.fieldData.forEach(x => {
            if ((x.fieldDeductionTypeName !== null && x.fieldDeductionTypeName !== undefined) && x.filedDeductionTempId !== 0) {
                fieldDeductionNames.push(x.fieldDeductionTypeName);
                fieldDeductionIds.push((x.filedDeductionTempId + "_Kg_Fi"));
                csvFieldsData.push({ label: ("Field " + x.fieldDeductionTypeName), value: (x.filedDeductionTempId + "_Kg_Fi") })
            }
        });

        fieldDeductionNames = [...new Set(fieldDeductionNames)];
        fieldDeductionIds = [...new Set(fieldDeductionIds)];

        csvFieldsData = csvFieldsData.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.value === v.value)) === i);

        copyOfInitialContentRownames.splice(6, 0, ...fieldDeductionIds);

        copyOfInitialCsvHeaders.splice(6, 0, ...csvFieldsData);

        copyOfInitialSumTableContentRownames.splice(3, 0, ...fieldDeductionIds);

        setCsvHeaders(copyOfInitialCsvHeaders);
        setSumFieldContentRowNames(copyOfInitialSumTableContentRownames);
        setContentRowNames(copyOfInitialContentRownames);
        setFieldColumnNames(fieldDeductionNames);

        return {
            contentRowNames: copyOfInitialContentRownames,
            fieldDeductionNames: fieldDeductionNames,
            fieldDeductionIds: fieldDeductionIds,
            csvHeadersData: copyOfInitialCsvHeaders
        }
    }

    function mergeSumTableFieldData(data, bagCountByCp) {
        var mergedResult = [];

        data.forEach(x => {
            if (mergedResult.length === 0) {
                mergedResult.push(setDefaultSumFieldValues(x));
            } else {
                var duplicateRecord = mergedResult.find(a => a.fieldCollectionPointID === x.fieldCollectionPointID);

                if (duplicateRecord) {
                    duplicateRecord.fieldGrossAmount_Kg = checkValueisUndifined(duplicateRecord.fieldGrossAmount_Kg) + checkValueisUndifined(x.fieldGrossAmount);
                    duplicateRecord.fieldNetAmount_Kg = checkValueisUndifined(duplicateRecord.fieldNetAmount_Kg) + checkValueisUndifined(x.fieldNetAmount);
                    duplicateRecord[x.filedDeductionTempId + "_Kg_Fi"] = checkValueisUndifined(duplicateRecord[x.filedDeductionTempId + "_Kg_Fi"])
                        + checkValueisUndifined(x.fieldDeductionAmount);
                } else {
                    mergedResult.push(setDefaultSumFieldValues(x));
                }
            }
        });

        mergedResult.forEach(x => {
            var result = bagCountByCp.find(y => y.id === x.fieldCollectionPointID);
            x.fieldNumberOfUnits = result.value;
        })


        return mergedResult;
    }

    function checkValueisUndifined(value) {
        if (value === undefined) {
            return 0;
        } else {
            return parseFloat(value);
        }
    }

    function mergeFieldData(data) {
        var mergedResult = [];

        data.forEach(x => {
            if (mergedResult.length === 0) {
                mergedResult.push(setDefaultFieldValues(x));
            } else {
                var duplicateRecord = mergedResult.find(a => a.productCollectionDetailsID === x.productCollectionDetailsID
                    && a.fieldCollectionPointID === x.fieldCollectionPointID);

                if (duplicateRecord) {
                    duplicateRecord[x.filedDeductionTempId + "_Kg_Fi"] = (duplicateRecord[x.filedDeductionTempId + "_Kg_Fi"] === undefined ? 0
                        : parseFloat(duplicateRecord[x.filedDeductionTempId + "_Kg_Fi"])) + parseFloat(x.fieldDeductionAmount);
                } else {
                    mergedResult.push(setDefaultFieldValues(x));
                }

            }
        });

        return mergedResult;
    }

    function setDefaultFieldValues(record) {
        var newRecord = {
            type: 1,
            fieldCardNumber: record.fieldCardNumber,
            fieldCollectionPointCode: record.fieldCollectionPointCode,
            fieldCollectionPointID: record.fieldCollectionPointID,
            fieldCollectionPointName: record.fieldCollectionPointName,
            fieldGrossAmount_Kg: record.fieldGrossAmount,
            fieldNetAmount_Kg: record.fieldNetAmount,
            fieldActualAmount_Kg: record.FieldActualAmount,
            collectionTypeName: record.collectionTypeName,
            filedRegistrationNumber: record.filedRegistrationNumber,
            filedTagNumber: record.filedTagNumber,
            productCollectionDetailsID: record.productCollectionDetailsID,
            productCollectionID: record.productCollectionID,
            filedDate: record.weightReadTime.split("T")[0],
            filedTime: record.weightReadTime.split("T")[1],
            name: record.name,
            collectionTypeID: record.collectionTypeID
        };

        if (record.filedDeductionTempId !== null && record.fieldDeductionAmount !== null) {
            newRecord[record.filedDeductionTempId + "_Kg_Fi"] = record.fieldDeductionAmount;
        }

        return newRecord;
    }

    function setDefaultSumFieldValues(record) {
        var newRecord = {
            type: 1,
            fieldCollectionPointID: record.fieldCollectionPointID,
            fieldCollectionPointName: record.fieldCollectionPointName,
            fieldGrossAmount_Kg: record.fieldGrossAmount,
            fieldNetAmount_Kg: record.fieldNetAmount,
            fieldActualAmount_Kg: record.FieldActualAmount,
            fieldNumberOfUnits: record.fieldNumberOfUnits
        };

        if (record.filedDeductionTempId !== null && record.fieldDeductionAmount !== null) {
            newRecord[record.filedDeductionTempId + "_Kg_Fi"] = record.fieldDeductionAmount;
        }

        return newRecord;
    }

    function createDataTable(contentResult, dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                destroy: x === '#factoryRouteWeighReportPdf' ? true : false,
                searching: x === '#factoryRouteWeighReportPdf' ? false : true,
                paging: x === '#factoryRouteWeighReportPdf' ? false : true,
                scrollX: false,
                order: [[1, 'asc']],
                rowGroup: {
                    startRender: null,
                    endRender: function (rows, group) {

                        var dynamicCountVariable = [];

                        for (var i = 0; i < contentResult.contentRowNames.length; ++i) {
                            if (i > 3) {
                                dynamicCountVariable[i] = rows
                                    .data()
                                    .pluck(i)
                                    .reduce(function (a, b) {
                                        return a + b * 1;
                                    }, 0);
                            }
                        }

                        var rowData = '';

                        for (var i = 0; i < contentResult.contentRowNames.length; ++i) {
                            if (i === 4) {
                                rowData += '<td style="text-align:right"><b>' + dynamicCountVariable[i] + '</b></td>';
                            } else if (i > 4 && contentResult.contentRowNames.length !== (i + 1)) {
                                rowData += '<td style="text-align:right"><b>' + dynamicCountVariable[i].toFixed(2) + '</b></td>';
                            } else if (contentResult.contentRowNames.length === i + 1) {
                                rowData += '<td/>';
                            }
                        }

                        return $('<tr/>')
                            .append('<td></td>')
                            .append('<td></td>')
                            .append('<td></td>')
                            .append('<td><b>Total for ' + group + '</b></td>')
                            .append(rowData);
                    },
                    dataSrc: 1
                }
            })
        });
    }

    function createFile() {
        var settings = {
            sheetName: 'FactoryRouteWeighReport',
            fileName: 'Factory Route Weigh Report',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: "0",
            date: ""
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            date: searchForm.date
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Factory Route Weigh Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionVariance.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionVariance.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionVariance.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionVariance)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row pb-3">
                                        <div className="col-md-6">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th style={{ fontWeight: "bold" }}>Route Name</th>
                                                        <th style={{ fontWeight: "bold" }}>Bag Count</th>
                                                        <th style={{ fontWeight: "bold" }}>Field Gross /Kg</th>
                                                        {fieldColumnNames.map((x, index) => {
                                                            return (
                                                                <th scope="col" key={index} style={{ fontWeight: "bold" }}>{x + " /Kg"}</th>
                                                            )
                                                        })}
                                                        <th style={{ fontWeight: "bold" }}>Field Net /Kg</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <TableContentForSumLeafCollectionVarianceReport
                                                        data={sumTableData}
                                                        contentRowNames={sumFieldContentRowNames}
                                                        hasEdit={false}
                                                    />
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <th>Total</th>
                                                        <th style={{ textAlign: "right", fontWeight: "bold" }}>{fullTotalRow.bagCount}</th>
                                                        {contentRowNames.map((x, i) => {
                                                            var res = fullTotalRow.find(y => y.name === x);

                                                            if (res) {
                                                                return (
                                                                    <th key={i} style={{ textAlign: "right", fontWeight: "bold" }}>{res.value.toFixed(2)}</th>
                                                                );
                                                            } else if (res === undefined && x.includes("_Kg")) {
                                                                return (
                                                                    <th key={i} style={{ textAlign: "right", fontWeight: "bold" }}>{(0).toFixed(2)}</th>
                                                                );
                                                            }

                                                        })}
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <table id="factoryRouteWeighReport" className="datatable-multi-row"
                                                    style={{ overflowX: "auto", whiteSpace: "nowrap", width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Date</th>
                                                            <th>Route Name</th>
                                                            <th>Reg Number</th>
                                                            <th>Reg Name</th>
                                                            <th>Bag Count</th>
                                                            <th>Gross /Kg</th>
                                                            {fieldColumnNames.map((x, index) => {
                                                                return (
                                                                    <th scope="col" key={index}>{x + " /Kg"}</th>
                                                                )
                                                            })}
                                                            <th>Net /Kg</th>
                                                            <th>Leaf Type</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForFactoryRouteWeighReport
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan="4">Total For Day</th>
                                                            <th style={{ textAlign: "left" }}>Bag Count: {fullTotalRow.bagCount}</th>
                                                            {contentRowNames.map((x, i) => {
                                                                var res = fullTotalRow.find(y => y.name === x);

                                                                if (res) {
                                                                    return (
                                                                        <th key={i} style={{ textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                                                    );
                                                                } else if (res === undefined && x.includes("_Kg")) {
                                                                    return (
                                                                        <th key={i} style={{ textAlign: "right" }}>{(0).toFixed(2)}</th>
                                                                    );
                                                                }

                                                            })}
                                                            <th></th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-4">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Factory Route Weigh Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} fieldColumnNames={fieldColumnNames}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} sumTableTotal={sumTableTotal}
                                            fullTotalRow={fullTotalRow}
                                            sumTableData={sumTableData} sumFieldContentRowNames={sumFieldContentRowNames} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
